'use strict';

class MhsGearsAdminView {
  constructor() {
    'ngInject';
  }
}

export default MhsGearsAdminView;
